/* eslint-disable no-unused-expressions */
import { createSlice } from '@reduxjs/toolkit'

// set all inital values to be the first value in the dropdown
const initialState = {
  pedestrian_facility_type: '',
  buffer_width: '',
  buffer_quality: '',
  landscape_buffer_street_trees: '',
  usable_sidewalk_width: '',
  sidewalk_quality: '',
  active_building_frontage: '',
  comfort_zone_width: '',
  sidewalk_accessibility: '',
  lighting: '',
  heavy_vehicles: '',
  crossing_spacing: '',
  special_considerations: [],
  crossing_improvements: [],
  prevailing_posted_speed: '',
  travel_lanes: '',
  pedestrian_tier: '',
  land_use_context: '',
  scores: {}
}

const pedestrian = createSlice({
  name: 'pedestrian',
  initialState,
  reducers: {
    setPedestrianInputs(state, action) {
      const { field, value } = action.payload
      if (
        field === 'crossing_improvements' ||
        field === 'special_considerations'
      ) {
        // If filed already includes value remove it / add
        state[field] = state[field].includes(value)
          ? state[field].filter((input) => input !== value)
          : [...state[field], value]
      } else {
        state[field] = value
      }
    },
    setPedestrianScores(state, action) {
      const { field, value } = action.payload
      state.scores = { ...state.scores, [field]: value }
    },
    resetPedestrianInputs(state) {
      return initialState
    },
    setAllPedestrianInputs(state, action) {
      return action.payload
    }
  }
})

export const {
  setPedestrianInputs,
  setPedestrianScores,
  resetPedestrianInputs,
  setAllPedestrianInputs
} = pedestrian.actions
export default pedestrian.reducer
